import React from 'react';
import { css } from '@emotion/react';
import { ButtonLink } from 'components/ButtonLink';
import { routes } from 'routes';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { PaddingStyle } from 'styles/PaddingStyle';
import { theme } from 'styles/theme';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { ArtistItem } from './components/ArtistItem';
import { Artist, useBookerArtistsQuery } from 'generated/graphql';

export const ScreenArtists = () => {
	// const [artists, _executeArtists] = useQuery({ query: QUERY_BOOKER_ARTISTS });
	// const { data, fetching } = artists;

	const [{ data, fetching }] = useBookerArtistsQuery();

	return (
		<div
			css={css`
				width: 100%;
			`}
		>
			<Header>
				<Heading
					left={
						<div
							css={css`
								display: flex;
								align-items: center;
							`}
						>
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
									margin-right: 24px;
								`}
							>
								Interpreti
							</h1>

							<ButtonLink small to={routes.booker.artistCreate}>
								Přidat interpreta
							</ButtonLink>
						</div>
					}
				></Heading>
			</Header>

			{!fetching && !data && <div>Je to prazdny more</div>}

			{fetching ? (
				<SpinnerBlock />
			) : (
				!!data && (
					<div
						css={[
							PaddingStyle({ p: 32 }),
							css`
								max-width: 720px;
								padding-top: 24px;
							`,
						]}
					>
						{data?.bookerArtists?.map((item: Artist, index: number) => {
							return item && <ArtistItem item={item} key={index} />;
						})}
					</div>
				)
			)}
		</div>
	);
};

export const ListingItemStyle = () => css`
	display: flex;
	border: 1px solid #f0f0ff;
	margin-bottom: 4px;
	padding: 16px 20px;
	border-radius: 12px;
	justify-content: space-between;

	color: ${theme.color.text['400']};

	&:hover {
		background: #fafaff;
		color: ${theme.color.text['400']};
		text-decoration: none;
		cursor: pointer;
	}
`;
